import React from 'react';
import { jsx as ___EmotionJSX } from "@emotion/react";
const SVG = ({
  className = '',
  size = '24'
}) => ___EmotionJSX("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: size,
  height: size,
  className: className,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: "2",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, ___EmotionJSX("path", {
  d: "M1.71397998,2 C1.50574475,1.99734416 1.30697963,2.08785953 1.17100328,2.24732477 C1.03502695,2.40679001 0.975758232,2.6188819 1.00909596,2.82670687 L4.00132862,21.1911084 C4.07828437,21.6549914 4.47358908,21.9960436 4.93882436,22 L19.2937874,22 C19.6429818,22.0044839 19.9428246,21.7498492 19.9986714,21.4013334 L22.990904,2.83027001 C23.0242418,2.62244503 22.964973,2.41035316 22.8289967,2.2508879 C22.6930203,2.09142266 22.4942553,2.00090729 22.2860201,2.00362253 L1.71397998,2 Z M14.3790035,16 L9.75266908,16 L8.5,9 L15.5,9 L14.3790035,16 Z"
}), ' ');
export default SVG;